import { lightTheme } from "@/customTheme"

const SvgComponent = ({ size, disabled }: { size: number, disabled?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size} height={size}
    fill="none"
  >
    <path
      fill={disabled ? lightTheme.colors.icon.disable : lightTheme.colors.blackGray}
      d="m9.951 5.255-2.92 2.918h2.55V8.17h5.067a5.324 5.324 0 0 1 5.324 5.323v.888a5.325 5.325 0 0 1-5.325 5.324H9.58v-1.775h5.068a3.55 3.55 0 0 0 3.55-3.55v-.887a3.55 3.55 0 0 0-3.55-3.549h-1.775v.002H7.03l2.922 2.922-1.255 1.255L4.26 9.687a.888.888 0 0 1 0-1.254L8.696 4l1.255 1.255Z"
    />
  </svg>
)
export default SvgComponent
